define([
    './button/button',
    'edge/platform/atomic_design/molecules/module'
], (Button)=> {
    return angular.module('edge.platform.atomic_design', [
        'edge.platform.atomic_design.molecules'
    ])
        .directive('gwButton', Button);
});


// WEBPACK FOOTER //
// ../common/js/src/edge/platform/atomic_design/module.js